<label [for]="identifier" [class.required]="required">{{ label | translate }}</label>
<mat-form-field [class.is-invalid]="hasErrors" class="w-100">
  <input
    type="text"
    [placeholder]="placeholder | translate"
    [id]="identifier"
    [attr.data-testid]="identifier"
    [value]="displayValue"
    [title]="displayValue"
    (input)="onInputChange($event.target['value'])"
    [matAutocomplete]="auto"
    matInput
    [disabled]="isDisabled"
    (blur)="onBlur()"
    #trigger="matAutocompleteTrigger" />
  <!--For the control value -->
  <input [disabled]="isDisabled" [(ngModel)]="value" type="hidden" class="hidden" />

  <div matSuffix class="d-flex gap-1 justify-content-center align-items-center">
    @if (displayValue?.length) {
      <app-icon
        mat-icon-button
        [identifier]="identifier + '-clear'"
        (clicked)="clearInput(auto)"
        iconType="material"
        iconName="clear"
        [isClickable]="!isDisabled"
        customClass="icon-size" />
    }
    <app-icon
      mat-icon-button
      [identifier]="identifier + '-toggle'"
      (click)="openOrClosePanel(trigger, $event)"
      [iconName]="arrowIcon()"
      [isClickable]="!isDisabled"
      iconType="material" />
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    [attr.data-testid]="identifier + '-autocomplete'"
    [requireSelection]="isRequired"
    (optionSelected)="selectItem($event.option.value)"
    (closed)="updateArrowIcon()"
    (opened)="onPanelOpened()">
    @for (item of filteredItems(); track trackByFn(i, item); let i = $index) {
      <mat-option [attr.data-cy]="identifier + '-item-' + i" [value]="item | readFieldValue: bindLabel">
        {{ item | readFieldValue: bindLabel }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<app-form-control-errors
  [identifier]="identifier"
  [control]="control"
  [errorTraductionKeyGroup]="errorTraductionKeyGroup" />
